import React from 'react';
import { Button, Dropdown, Form } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import Message from '../Message.js';
import moment from 'moment';
import { editData } from '../dataHelper';

class Edit extends React.Component {
  state = {
    plateNumberList: this.props.plateNumberList,
    registrationNumber: '',
    startDate: null,
    place: '',
    damageItems: this.props.titles,
    damageItem: '',
    particulars: '',
    branches: this.props.branches,
    branch: '',
    remarks: '',
    cost: '',
    eventId: '',
    submitted: false,
    messageShow: false,
    messageType: '',
    messageInfo: '',
  };

  componentDidMount() {
    const {
      asset_id,
      _id,
      time,
      damage_item,
      branch,
      place,
      particulars,
      remarks,
      cost,
    } = this.props.task;

    this.setState({
      eventId: _id.$oid,
      registrationNumber: asset_id.$oid,
      startDate: time ? moment(time.$date) : null,
      place,
      damageItem: damage_item,
      particulars,
      branch,
      remarks,
      cost,
    });
  }

  handleStartDateChange = (value) => {
    this.setState({
      startDate: value,
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleAssetSelect = (e, data) => {
    this.setState({ registrationNumber: data.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ messageShow: false, submitted: true });
    const {
      eventId,
      registrationNumber,
      startDate,
      place,
      damageItem,
      particulars,
      branch,
      remarks,
      cost,
    } = this.state;

    const data = {
      event_id: eventId,
      asset_id: registrationNumber,
      time: moment(startDate).unix(),
      place,
      damage_item: damageItem,
      particulars,
      current_branch: branch,
      remarks,
      cost: cost ? cost : 0,
    };

    editData(`${this.props.org}_incident`, data)
      .then((response) => {
        const { message, status } = response.data;

        if (status === 'success') {
          this.setState({
            messageShow: true,
            messageInfo: message,
            messageType: 'positive',
            submitted: false,
          });
          setTimeout(() => {
            this.setState({ messageShow: false });
          }, 3000);
        } else if (status === 'failed') {
          this.setState({
            messageShow: true,
            messageInfo: message,
            messageType: 'warning',
            submitted: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ submitted: false });
      });
  };

  render() {
    const {
      plateNumberList,
      startDate,
      place,
      damageItem,
      particulars,
      branch,
      registrationNumber,
      remarks,
      damageItems,
      branches,
      cost,
      messageShow,
      messageType,
      messageInfo,
      submitted,
    } = this.state;

    return (
      <div style={{ margin: '10px auto', width: '70%' }}>
        <Form onSubmit={this.handleSubmit}>
          <Form.Field>
            <label>Date</label>
            <DatePicker
              selected={startDate}
              onChange={this.handleStartDateChange}
              dateFormat='LLL'
              showTimeSelect
            />
          </Form.Field>

          <Form.Field>
            <label>Registration No.</label>
            <Dropdown
              search
              selection
              options={plateNumberList}
              onChange={this.handleAssetSelect}
              value={registrationNumber}
            />
          </Form.Field>

          <Form.Field>
            <label name='place'>Place</label>
            <input
              value={place}
              onChange={this.handleChange}
              name='place'
              type='text'
            />
          </Form.Field>

          <Form.Field>
            <label name='damageItem'>Damage Item</label>
            <select
              placeholder='Select Damage Item'
              name='damageItem'
              value={damageItem}
              onChange={this.handleChange}
              style={{ textTransform: 'capitalize' }}
            >
              {damageItems.map((item) => (
                <option value={item} key={item}>
                  {item.split('_').join(' ')}
                </option>
              ))}
            </select>
          </Form.Field>

          <Form.Field>
            <label name='particulars'>Particulars</label>
            <input
              value={particulars}
              onChange={this.handleChange}
              name='particulars'
              type='text'
            />
          </Form.Field>

          <Form.Field>
            <label name='branch'>Branch</label>
            <select
              name='branch'
              value={branch}
              onChange={this.handleChange}
              style={{ textTransform: 'capitalize' }}
            >
              {branches.map((item) => (
                <option value={item} key={item}>
                  {item.split('_').join(' ')}
                </option>
              ))}
            </select>
          </Form.Field>

          <Form.Field>
            <label name='remarks'>Remarks</label>
            <textarea
              value={remarks}
              onChange={this.handleChange}
              name='remarks'
              type='text'
            />
          </Form.Field>

          <Form.Field>
            <label name='cost'>Cost</label>
            <input
              placeholder='Taka'
              value={cost}
              onChange={this.handleChange}
              name='cost'
              type='text'
            />
          </Form.Field>
        </Form>
        <br />
        {messageShow && <Message type={messageType} info={messageInfo} />}
        <Button
          primary
          disabled={submitted}
          loading={submitted}
          onClick={this.handleSubmit}
        >
          Submit
        </Button>
      </div>
    );
  }
}

export default Edit;
